module.exports = __webpack_public_path__ + "img/legal-service.1dc69f84.jpg";